<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/basic/user',title:'系统管理'},{title:'lyy测试专用'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="角色名称/描述">
							    <el-input clearable v-model="q.nameLikedesLike"></el-input>
							</el-form-item>
							<el-form-item label="　　选择收货地址">
							    <el-input clearable>
							        <i
							                class="el-icon-edit el-input__icon"
							                slot="suffix"
							                @click="handleIconClick">
							        </i>
							    </el-input>
							</el-form-item>
							<el-form-item label="是否可用">
							    <brselect category="YlSalesArea_chanpin"
							              @change="huidiaochange"
							              :v="q.delflag" v-model="q.delflag"></brselect>
							</el-form-item>
						</div>
                        
                        <div class="h-formBtnOut h-columnCenter">
                            <el-button class="h-btn h-formBtn" @click="yunwei">运维键</el-button>
                            <el-button class="h-btn h-formBtn" @click="showYonghuflagBtn">选择用户</el-button>

                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn" @click="uploaddownexcelflagbtn">导入excel</el-button>
                            <uploadexcel style="display: inline-block;margin-left: 0.1rem;" clsname="demoImportExcel" :startrow="4" @scallback="uploadExcelFilecallback"/>
                            <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                             clsname="demoImportExcel"
                                             :startrow="2"
                                             :extparams="q"
                                             @callback="uploadExcelFilecallback"/>
                        </div>
                    </el-form>
                </div>
            </div>
            <div class="h-table h-mrt30">
                <el-table
                        ref="ddtable"
                        :data="tableData"
                        stripe
						border
                        style="width: 100%"
                >
                    <el-table-column
                            prop="name"
                            label="名称"
							width="200"
							:show-overflow-tooltip="true"
                            >
                    </el-table-column>
                    <el-table-column
                            prop="id"
                            label="角色编码"
							width="200"
                           >
                    </el-table-column>
                    <el-table-column
                            prop="delflag"
                            label="是否可用"
							width="90"
                            >
                        <template slot-scope="scope">
                            {{scope.row.delflag|dictname('shifou_keyong')}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="des"
                            label="描述"
							:show-overflow-tooltip="true"
                            >
							<template slot-scope="scope">
								<div style="text-align: left;">
									{{scope.row.des}}
								</div>
							</template>
                    </el-table-column>
                    <el-table-column
                            prop="cucode"
                            label="创建人id"
							width="110"
                            >
                    </el-table-column>
                </el-table>
                <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
                    <pagination :page="q" @query="query"/>
                </div>
            </div>
            <areaSelect :visible.sync="showflag" @choseObj="choseObj" title="选择地址" v-if="showflag"/>
            <selectcustagent :visible.sync="showYonghuflag" v-if="showYonghuflag" @choseObj="choseYonghuObj"
                             title="选择用户"/>
        </div>
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import selectcustagent from '../../components/dialog/selectcustagent'
    import uploadexcel from '../../components/uploaddown/uploadexcel'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
            selectcustagent,
            uploadexcel
        },
        data() {
            return {
                uploaddownexcelflag: false,

                showflag: false,
                showYonghuflag: false,
                //table列表
                tableData: [],
                //弹出框
                dialogFormVisible: false,
                //查询属性
                q: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
            }
        },
        created() {
            this.query();
        },
        methods: {
            uploadExcelFilecallback(rd) {
                this.$msg.alert(rd);
            },
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },
            uploadExcelFilecallback(rd) {
                console.log(rd);
                this.$msg.msgs(rd)
            },
            uploadExcelFilecallback1(rd) {
                console.log(rd);
                this.$msg.msge(rd)
            },
            huidiaochange(v) {
                console.log(v)
            },
            //选择用户
            showYonghuflagBtn() {
                this.showYonghuflag = true;
            },
            choseYonghuObj(o) {
                console.log(o)
                this.showYonghuflag = false;
            },
            //选择用户 end
            choseObj(obj) {
                console.log(obj)
                this.showflag = false;
            },
            query(p) {
                ss.RoleService.page(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                })
            },
            yunwei() {
                this.$msg.confirm("确认执行?", () => {
                    ss.OrderMainService.yunwei().then(rd => {
                        this.$msg.msgs(rd.msg);
                    });
                })
            },
            handleFilter() {
                this.query();
                this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({path: '/personal/dealCenter'})
                })

            },
            handleIconClick() {
                this.showflag = true;
            }
        }
    }
</script>
